import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Location } from '../models/Location';
import { Pagination } from '../models/Pagination';
import { CacheService } from './cache.service';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';
import {map, takeLast} from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class LocationsService {
    constructor(
        private httpService: HttpService,
        private cacheService: CacheService
    ) {}

    getLocation(locationId: number): Observable<Location> {
        if (this.cacheService.hasItem('location', locationId)) {
            return of(this.cacheService.getItem('location', locationId));
        } else {
            return this.httpService.get<any>(environment.apiV1BaseUrl + '/supplychains/locations/' + locationId).pipe(
                map((location: Location) => this.cacheService. setItem('location', locationId, location))
            );
        }
    }

    getLocationsPaginated(
        paginationSize = 50,
        paginationOffset = 0,
        filters= {}
    ): Observable<Pagination> {
        let params = {
            paginationSize: paginationSize,
            paginationOffset: paginationOffset,
            filters
        };

        let httpParams: HttpParams = new HttpParams();

        Object.keys(params).forEach((k) => {
            params[k] && (httpParams = httpParams.set(k, params[k]));
        });

        return this.httpService.get<any>(environment.apiV1BaseUrl + '/supplychains/locations-paginated', {
            params: httpParams,
            observe: 'response'
        }).pipe(
            map((response) => {
                return <Pagination> {
                    paginationSize,
                    paginationOffset,
                    total: response.headers && response.headers.get('x-pagination') ? JSON.parse(response.headers.get('x-pagination')).totalCount : null,
                    items: <Array<Location>>response.body,
                }

            })
        );
    }

    getLocationsSearchPaginated(
        paginationSize = 50,
        startingAfter= null,
        endingBefore = null,
        paginationOffset = 0,
        q = null
    ): Observable<Pagination> {
        let params = {
            paginationSize,
            paginationOffset,
            startingAfter,
            endingBefore,
            q
        };

        let httpParams: HttpParams = new HttpParams();

        Object.keys(params).forEach((k) => {
            params[k] && (httpParams = httpParams.set(k, params[k]));
        });
        return this.httpService.get<any>(environment.apiV1BaseUrl + '/supplychains/locations-search', {
            params: httpParams,
            observe: 'response'
        }).pipe(
            map((response) => {
                return <Pagination> {
                    paginationSize,
                    paginationOffset,
                    startingAfter,
                    endingBefore,
                    total: response.headers && response.headers.get('x-pagination') ? JSON.parse(response.headers.get('x-pagination')).totalCount : null,
                    items: <Array<Location>>response.body,
                }
            })
        );
    }

}
